import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;

export default class TicketService {

  static getTicketsByParams = (params) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/ticket/find`;
      ApiService.postRudeRequest(resolve, reject, url, params);
    });
  };

  static createTicket = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/ticket/create`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };

  static deleteTicket = (id) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/ticket/delete`;  
      ApiService.delete(resolve, reject, url, id);
    });
  };

  static updateTicket = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/ticket/update`;
      ApiService.putRequest(resolve, reject, url, data);
    });
  };

  static changeTicketStatus = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/ticket/change-status`;
      ApiService.putRequest(resolve, reject, url, data);
    });
  };
}

